<template>
  <b-row>
    <b-col :cols='12'>
      <b-row v-if='this.editingVisit < 1'>
        <b-col :cols='12'>
          <h3>Resultados > Detalles</h3>
          <div v-if='this.searchCriteria.distributors'>
            Viendo visitas de
            <span v-if='this.searchCriteria.manager'>
              {{ this.searchCriteria.manager }} ({{ this.searchCriteria.distributors.join(', ') }})
            </span>
            <span v-else>
              {{ this.searchCriteria.distributors.join(', ') }}
            </span>
          </div>
          <p>
            <span style="color: #6daeb9;">
              AVISO: Puede haber registros fuera del rango de fechas porque se incluyen las visitas de las semanas completas (desde el Sábado anterior al inicio-hasta el Viernes posterior al fin)
            </span>
          </p>
          <b-btn class='mb-3' @click='goBackResults()' variant='primary'>Volver a resultados</b-btn>
        </b-col>
        <b-col :cols='12'>
          <table class="table fixed_header">
            <thead>
            <tr>
              <th style="min-width:75px">Acciones</th>
              <th v-if="searchCriteria['group'] === 'entidad'" style="min-width:350px">Entidad</th>
              <th v-else style="min-width:350px">Dirección</th>
              <th style="min-width:200px">Fecha planificada</th>
              <th style="min-width:200px">Fecha realizada</th>
              <th style="min-width:250px">Gestor</th>
              <th style="min-width:100px">Estado</th>
              <th style="min-width:200px">Tipo actividad</th>
              <th style="min-width:100px">Resultado</th>
              <th style="min-width:250px">Observaciones</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in tableItems" v-bind:key="item.id">
              <td style="min-width:75px">
                <b-dropdown variant="link" no-caret>
                  <template slot="button-content">
                    <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                  </template>
                  <b-dropdown-item-button @click="editRow(item.id_visita , $event)">Editar</b-dropdown-item-button>
                  <b-dropdown-item-button @click="removeRow(item.id_visita)">Eliminar</b-dropdown-item-button>
                </b-dropdown>
              </td>
              <td v-if="searchCriteria['group'] === 'entidad'" style="min-width:350px">{{ item.entidad }}</td>
              <td v-else style="min-width:350px">{{ item.direccion }}</td>
              <td style="min-width:200px">{{ item.fecha_hora_proxima_visita }}</td>
              <td style="min-width:200px">{{ item.fecha_hora_visita }}</td>
              <td style="min-width:250px">{{ item.gestor }}</td>
              <td style="min-width:100px">{{ item.status_visita }}</td>
              <td style="min-width:200px">{{ item.tipo_actividad }}</td>
              <td style="min-width:100px">{{ item.resultado }}</td>
              <td style="min-width:250px">{{ item.observaciones }}</td>
            </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
      <b-row v-else class="scroll">
        <b-col :cols='12'>
          <h3>Resultados > Detalles > Editando visita</h3>
        </b-col>
        <b-col :cols='12'>
          <ManageVisitsResultsDetailEdit :group='this.searchCriteria.group'
                                         v-if='editingVisit && searchCriteria.group !== "entidad"'
                                         :id-visita='this.editingVisit'></ManageVisitsResultsDetailEdit>
          <ManageVisitsEntitiesResultsEdit v-else-if='editingVisit && searchCriteria.group === "entidad"'
                                           :id-visita='this.editingVisit'
                                           :manager="searchCriteria['manager']"></ManageVisitsEntitiesResultsEdit>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<style>
.fixed_header tbody {
  display: block;
  overflow: auto;
  height: 500px;
  width: 100%;
}

.fixed_header thead tr {
  display: block;
}
</style>

<script>
/* eslint-disable */
import ManageVisitsResultsDetailEdit from './ManageVisitsResultsDetailEdit';
import ManageVisitsEntitiesResultsEdit from './ManageVisitsEntitiesResultsEdit';

export default {
  name: 'ManageVisitsResultsDetail',
  props: {
    searchCriteria: Object
  },
  components: {ManageVisitsResultsDetailEdit, ManageVisitsEntitiesResultsEdit},
  data () {
    return {
      editingVisit: 0,
      tableItems: [],
      tableFields: [
        {key: 'acciones'},
        {key: 'direccion'},
        {key: 'fecha_hora_proxima_visita', label: 'Fecha planificada'},
        {key: 'fecha_hora_visita', label: 'Fecha realizada'},
        {key: 'gestor'},
        {key: 'status_visita', label: 'Estado'},
        {key: 'tipo_actividad'},
        {key: 'resultado'},
        {key: 'observaciones'},
      ]
    };
  },
  computed: {},
  created: function () {
    this.editingVisit = 0;
    this.processData();
  },
  mounted: function () {
    this.editingVisit = 0;
  },
  methods: {
    goBackResults () {
      this.$parent.$parent.$parent.submitFilters();
      this.$parent.showManageVisitsResultsDetailPopup = false;
    },

    editRow (id) {
      this.editingVisit = id;
    },
    removeRow (id) {
      if (confirm('¿Seguro que quieres eliminar esta visita?')) {
        if (this.searchCriteria['group'] === 'entidad') {
          this.$http.delete('visita_entidad_detalle/' + id + '/').then(response => {
            this.processData();
          });
        } else if (this.searchCriteria['group'] === 'caldera') {
          this.$http.delete('visita_caldera_detalle/' + id + '/').then(response => {
            this.processData();
          });
        } else if (this.searchCriteria['group'] === 'comercial') {
          this.$http.delete('visita_comercial_detalle/' + id + '/').then(response => {
            this.processData();
          });
        }
      }
    },

    processData () {
      const start = this.searchCriteria['weeks'][0].startWeekDay.format('YYYY-MM-DD');
      const end = this.searchCriteria['weeks'][this.searchCriteria['weeks'].length - 1].endWeekDay.format('YYYY-MM-DD');

      if (this.searchCriteria['group'] === 'caldera') {
        this.$http.get('visita_caldera_detalle/', {
          params: {
            'keys': this.searchCriteria['keys'],
            'start': start,
            'end': end,
            'manager': this.searchCriteria['manager'],
            'distributors': this.searchCriteria['distributors']
          }
        }).then(response => {
          this.tableItems = response.data;
        });
      } else if (this.searchCriteria['group'] === 'comercial') {
        this.$http.get('visita_comercial_detalle/', {
          params: {
            'keys': this.searchCriteria['keys'],
            'start': start,
            'end': end,
            'manager': this.searchCriteria['manager'],
            'distributors': this.searchCriteria['distributors']
          }
        }).then(response => {
          this.tableItems = response.data;
        });
      } else if (this.searchCriteria['group'] === 'entidad') {
        this.$http.get('visita_entidad_detalle/', {
          params: {
            'keys': this.searchCriteria['keys'],
            'start': start,
            'end': end,
            'manager': this.searchCriteria['manager'],
            'distributors': this.searchCriteria['distributors']
          }
        }).then(response => {
          this.tableItems = response.data;
        });
      }
    }

  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/CommercialManagement/ManageVisitsResultsDetail.vue